const TOOLTIP_MAX_WIDTH = 280
const TOOLTIP_GAP = 8
const VIEWPORT_PAD = 8
const SELECTOR = ".backoffice-page__header-right .backoffice-btn[data-tooltip]"

const measureTooltip = (text) => {
  const el = document.createElement("div")
  el.setAttribute("aria-hidden", "true")
  el.textContent = text
  el.style.cssText = [
    "position: fixed",
    "left: -9999px",
    "top: 0",
    "box-sizing: border-box",
    "width: max-content",
    `max-width: ${TOOLTIP_MAX_WIDTH}px`,
    "padding: 7px 10px",
    "font-size: 12px",
    "font-weight: 500",
    "line-height: 1.35",
    "white-space: normal",
    "text-align: center"
  ].join(";")
  document.body.appendChild(el)
  const { width, height } = el.getBoundingClientRect()
  el.remove()
  return { width: Math.ceil(width), height: Math.ceil(height) }
}

const fitsBottom = (rect, width, height) => {
  const spaceBelow = window.innerHeight - rect.bottom - TOOLTIP_GAP
  if (spaceBelow < height + 4) return false

  // Bottom tooltip is centered on the trigger — also check horizontal overflow
  const centerX = rect.left + rect.width / 2
  const left = centerX - width / 2
  const right = centerX + width / 2
  return left >= VIEWPORT_PAD && right <= window.innerWidth - VIEWPORT_PAD
}

const resolvePlacement = (trigger) => {
  const text = trigger.getAttribute("data-tooltip")
  if (!text) return "bottom"

  const rect = trigger.getBoundingClientRect()
  const { width, height } = measureTooltip(text)
  const spaceLeft = rect.left - TOOLTIP_GAP
  const spaceRight = window.innerWidth - rect.right - TOOLTIP_GAP

  if (fitsBottom(rect, width, height)) return "bottom"
  // Header actions sit on the right: prefer left when bottom would be clipped
  if (spaceLeft >= width + 4) return "left"
  if (spaceRight >= width + 4) return "right"
  return spaceLeft >= spaceRight ? "left" : "right"
}

const placeTooltip = (trigger) => {
  trigger.setAttribute("data-tooltip-placement", resolvePlacement(trigger))
}

const clearPlacement = (trigger) => {
  trigger.removeAttribute("data-tooltip-placement")
}

const onEnter = (event) => {
  const trigger = event.target.closest?.(SELECTOR)
  if (!trigger) return
  placeTooltip(trigger)
}

const onLeave = (event) => {
  const trigger = event.target.closest?.(SELECTOR)
  if (!trigger) return
  if (trigger.contains(event.relatedTarget)) return
  clearPlacement(trigger)
}

export const initBackofficeHeaderTooltips = () => {
  if (document.documentElement.dataset.backofficeHeaderTooltipsInit === "true") return
  document.documentElement.dataset.backofficeHeaderTooltipsInit = "true"

  document.addEventListener("mouseover", onEnter)
  document.addEventListener("mouseout", onLeave)
  document.addEventListener("focusin", onEnter)
  document.addEventListener("focusout", onLeave)
}
